import axios from "axios";
import cookies from "js-cookie";

const baseURL = `${window.location.origin}/internal-api`;

export const requestREST = axios.create({
  baseURL,
  withCredentials: true,
  headers: {
    Authorization: `Bearer ${cookies.get("token")}`,
  },
});
